<template>
  <v-row justify="center">
    <v-dialog :value="isVisible" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ isEdit ? "Modifier un thème" : "Créer un thème" }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="theme">
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Nom du thème (Français)"
                  required
                  v-model="theme.title"
                  :placeholder="theme.title"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Nom du thème (Anglais)"
                  v-model="theme.titleEN"
                  :placeholder="theme.titleEN"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-1" text @click="$emit('cancel')">
            Annuler
          </v-btn>
          <v-btn color="blue darken-1" text @click="$emit('submit')">
            {{ isEdit ? "Modifier" : "Créer" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "DialogEditTheme",
  model: {
    prop: "theme",
    event: "input",
  },
  props: {
    isVisible: Boolean,
    theme: Object,
  },
  computed: {
    isEdit: function() {
      return this.theme && this.theme['@id'];
    }
  }
};
</script>
